// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"494":"0f0a8157c28951d0","763":"09e7068c31ce7471"}[chunkId] + ".js";
};